import { formatCalendarDate, formatCalendarDateForInput } from "./calendarDate.mjs";
import { formatTimestampDateForInput } from "./timestampDate.mjs";

export function isAllDayTask(task) {
  if (typeof task?.all_day === "boolean") return task.all_day;
  if (typeof task?.due_all_day === "boolean") return task.due_all_day;
  // Task-list responses omit the flags and encode all-day tasks as exact midnight.
  // Inspect the supplied clock before any timezone conversion; explicit flags win above.
  return (
    typeof task?.due_date === "string" &&
    /^\d{4}-\d{2}-\d{2}T00:00:00(?:\.0+)?(?:Z|[+-]00:?00)?$/i.test(task.due_date.trim()) &&
    Boolean(formatCalendarDateForInput(task.due_date))
  );
}

export function getTaskCalendarDate(task) {
  return isAllDayTask(task)
    ? formatCalendarDateForInput(task?.due_date)
    : formatTimestampDateForInput(task?.due_date);
}

export function formatTaskDueDate(task) {
  return formatCalendarDate(getTaskCalendarDate(task));
}
